import { render } from "./CloudUpload.vue?vue&type=template&id=f0f63e84"
import script from "./CloudUpload.vue?vue&type=script&lang=js"
export * from "./CloudUpload.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__